export default __webpack_public_path__ + "static/media/qanon_header.fd8dff10.jpg";